import PropertyDeliveries from './PropertyDeliveries';
import PropertyDeliveriesError from './PropertyDeliveriesError';
export default PropertyDeliveries;
export { PropertyDeliveriesError };
